import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { authwsEnvironment } from '../authws-environment';

/**
 * Un-assigns product/roles from an SSO User
 * @param accountId Id of the account
 * @param request.id Id of the user
 * @param request.email user's email
 * @param request.firstName user's first name
 * @param request.lastName user's last name
 * @param request.productRoles array of products and their corresponding roles
 */
export function deleteProductsAccountsUser(
  this: unknown,
  accountId: number,
  request: {
    email: string;
    firstName: string;
    id: number;
    lastName: string;
    productRoles: {
      product: {
        name: string;
      };
      role: {
        name: string;
      };
    }[];
  }
) {
  return fromFetch(
    new Request(
      `${
        authwsEnvironment.resolve(this).productsUrl
      }/accounts/${encodeURIComponent(accountId)}/user`,
      {
        method: 'DELETE',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
        body: JSON.stringify(request),
      }
    )
  ).pipe(
    selectData(
      z.object({
        data: z.string(),
        errorList: z.array(
          z.object({
            code: z.string(),
            description: z.string(),
          })
        ),
        status: z.union([z.literal('Successful'), z.literal('Failed')]),
      })
    )
  );
}
